import { createAction } from 'redux-actions'
import memoize from 'app/api/memoize'
import { getOrgId } from 'app/selectors/Org'
import * as constants from './constants'
import { api, parseUser } from './api'
import { currentUser, currentUserLoaded } from './selectors'
import * as GateSelectors from 'app/modules/gates/selectors'
import * as DemoConstants from './demodata'
import { List } from 'immutable'

export const fetchCurrentUserStarted = createAction(constants.FETCH_CURRENT_USER_STARTED)
export const fetchCurrentUserFailed = createAction(constants.FETCH_CURRENT_USER_FAILED)
export const patchCurrentUserStarted = createAction(constants.PATCH_CURRENT_USER_STARTED)
export const patchCurrentUserFailed = createAction(constants.PATCH_CURRENT_USER_FAILED)
export const receiveCurrentUser = createAction(constants.RECEIVE_CURRENT_USER)

export const fetchClearbitForEmail = createAction(constants.FETCH_CLEARBIT_FOR_EMAIL)
export const fetchClearbitForEmailSuccess = createAction(constants.FETCH_CLEARBIT_FOR_EMAIL_SUCCESS)
export const fetchClearbitForEmailFailed = createAction(constants.FETCH_CLEARBIT_FOR_EMAIL_FAILED)
export const fetchClearbitForEmailPending = createAction(constants.FETCH_CLEARBIT_FOR_EMAIL_PENDING)

export const fetchGoogleScopes = createAction(constants.FETCH_GOOGLE_SCOPES)
export const fetchGoogleScopesSuccess = createAction(constants.FETCH_GOOGLE_SCOPES_SUCCESS)
export const fetchGoogleScopesFailed = createAction(constants.FETCH_GOOGLE_SCOPES_FAILED)
export const fetchGoogleScopesPending = createAction(constants.FETCH_GOOGLE_SCOPES_PENDING)

export const fetchEmailSignature = createAction(constants.FETCH_EMAIL_SIGNATURE)
export const fetchEmailSignatureSuccess = createAction(constants.FETCH_EMAIL_SIGNATURE_SUCCESS)
export const fetchEmailSignatureFailed = createAction(constants.FETCH_EMAIL_SIGNATURE_FAILED)
export const fetchEmailSignaturePending = createAction(constants.FETCH_EMAIL_SIGNATURE_PENDING)

export const resetEmailSignature = createAction(constants.RESET_EMAIL_SIGNATURE)

export const setEmailSignature = createAction(constants.SET_EMAIL_SIGNATURE)
export const setEmailSignatureSuccess = createAction(constants.SET_EMAIL_SIGNATURE_SUCCESS)
export const setEmailSignatureFailed = createAction(constants.SET_EMAIL_SIGNATURE_FAILED)

export const fetchOrgUsersStarted = createAction(constants.FETCH_ORG_USERS_STARTED)
export const fetchOrgUsersFailed = createAction(constants.FETCH_ORG_USERS_FAILED)
export const receiveOrgUsers = createAction(constants.RECEIVE_ORG_USERS)
export const receiveOrgUser = createAction(constants.RECEIVE_ORG_USER)

export const receiveGates = createAction(constants.RECEIVE_GATES)

export const turnOffManualAway = createAction(constants.TURN_OFF_MANUAL_AWAY)
export const turnOffManualAwayPending = createAction(constants.TURN_OFF_MANUAL_AWAY_PENDING)
export const turnOffManualAwaySuccess = createAction(constants.TURN_OFF_MANUAL_AWAY_SUCCESS)
export const turnOffManualAwayFailure = createAction(constants.TURN_OFF_MANUAL_AWAY_FAILURE)

export const fetchOrgSignature = createAction(constants.FETCH_ORG_SIGNATURE)
export const fetchOrgSignaturePending = createAction(constants.FETCH_ORG_SIGNATURE_PENDING)
export const fetchOrgSignatureFailed = createAction(constants.FETCH_ORG_SIGNATURE_FAILED)
export const fetchOrgSignatureCancelled = createAction(constants.FETCH_ORG_SIGNATURE_CANCELLED)
export const fetchOrgSignatureSuccess = createAction(constants.FETCH_ORG_SIGNATURE_SUCCESS)

export const fetchOrgMultiSignature = createAction(constants.FETCH_ORG_MULTI_SIGNATURE)
export const fetchOrgMultiSignaturePending = createAction(constants.FETCH_ORG_MULTI_SIGNATURE_PENDING)
export const fetchOrgMultiSignatureFailed = createAction(constants.FETCH_ORG_MULTI_SIGNATURE_FAILED)
export const fetchOrgMultiSignatureCancelled = createAction(constants.FETCH_ORG_MULTI_SIGNATURE_CANCELLED)
export const fetchOrgMultiSignatureSuccess = createAction(constants.FETCH_ORG_MULTI_SIGNATURE_SUCCESS)

export const disconnectGmailAccount = createAction(constants.DISCONNECT_GMAIL_ACCOUNT)
export const disconnectGmailAccountPending = createAction(constants.DISCONNECT_GMAIL_ACCOUNT_PENDING)
export const disconnectGmailAccountSuccess = createAction(constants.DISCONNECT_GMAIL_ACCOUNT_SUCCESS)
export const disconnectGmailAccountFailure = createAction(constants.DISCONNECT_GMAIL_ACCOUNT_FAILURE)

export const fetchIndividualUserConvoLimit = createAction(constants.FETCH_INDIVIDUAL_USER_CONVO_LIMIT)
export const fetchIndividualUserConvoLimitPending = createAction(constants.FETCH_INDIVIDUAL_USER_CONVO_LIMIT_PENDING)
export const fetchIndividualUserConvoLimitFailed = createAction(constants.FETCH_INDIVIDUAL_USER_CONVO_LIMIT_FAILED)
export const fetchIndividualUserConvoLimitCancelled = createAction(constants.FETCH_INDIVIDUAL_USER_CONVO_LIMIT_CANCELLED)
export const fetchIndividualUserConvoLimitSuccess = createAction(constants.FETCH_INDIVIDUAL_USER_CONVO_LIMIT_SUCCESS)

export const updateIndividualUserConvoLimit = createAction(constants.UPDATE_INDIVIDUAL_USER_CONVO_LIMIT)
export const updateIndividualUserConvoLimitPending = createAction(constants.UPDATE_INDIVIDUAL_USER_CONVO_LIMIT_PENDING)
export const updateIndividualUserConvoLimitFailed = createAction(constants.UPDATE_INDIVIDUAL_USER_CONVO_LIMIT_FAILED)
export const updateIndividualUserConvoLimitCancelled = createAction(constants.UPDATE_INDIVIDUAL_USER_CONVO_LIMIT_CANCELLED)
export const updateIndividualUserConvoLimitSuccess = createAction(constants.UPDATE_INDIVIDUAL_USER_CONVO_LIMIT_SUCCESS)

export const updateUser = createAction(constants.UPDATE_USER)
export const updateUserPending = createAction(constants.UPDATE_USER_PENDING)
export const updateUserFailed = createAction(constants.UPDATE_USER_FAILED)
export const updateUserCancelled = createAction(constants.UPDATE_USER_CANCELLED)
export const updateUserSuccess = createAction(constants.UPDATE_USER_SUCCESS)

export const fetchCurrentUser = memoize(() => (dispatch, getState) => {
  if (!currentUserLoaded(getState())) {
    dispatch(fetchCurrentUserStarted())
    return api
      .fetchCurrent()
      .then(user => dispatch(receiveCurrentUser(user)))
      .catch(error => dispatch(fetchCurrentUserFailed(error)))
  } else {
    return Promise.resolve()
  }
})

export const refreshCurrentUser = () => dispatch => {
  dispatch(fetchCurrentUserStarted())

  return api
    .fetchCurrent()
    .then(user => {
      dispatch(receiveCurrentUser(user))
      dispatch(receiveGates(user.gates))
    })
    .catch(error => {
      dispatch(fetchCurrentUserFailed(error))
      return Promise.reject()
    })
}

export const updateCurrentUser = updates => (dispatch, getState) => {
  dispatch(patchCurrentUserStarted())
  const user = currentUser(getState())
  return api
    .patchUser(user.id, updates)
    .then(user => dispatch(receiveCurrentUser(user)))
    .catch(error => {
      dispatch(patchCurrentUserFailed(error))
      return Promise.reject()
    })
}

// should really live under org
export const fetchOrgUsers = () => (dispatch, getState) => {
  if (GateSelectors.hasDemoOrg(getState())) {
    dispatch(fetchOrgUsersStarted())
    const orgId = getOrgId(getState())
    return api
      .fetchUsers(orgId)
      .then(users => {
        return dispatch(receiveOrgUsers(users.merge(List(DemoConstants.users(orgId)).map(parseUser))))
      })
      .catch(error => dispatch(fetchOrgUsersFailed(error)))
  } else {
    dispatch(fetchOrgUsersStarted())
    const orgId = getOrgId(getState())
    return api
      .fetchUsers(orgId)
      .then(users => {
        return dispatch(receiveOrgUsers(users))
      })
      .catch(error => dispatch(fetchOrgUsersFailed(error)))
  }
}

export const updateOrgUserStatus = (id, updates) => dispatch => {
  return api
    .setOrgUserStatus(id, updates)
    .then(() => dispatch(fetchOrgUsers()))
    .catch(error => {
      dispatch(patchCurrentUserFailed(error))
      return Promise.reject()
    })
}



// WEBPACK FOOTER //
// ./src/scripts/app/modules/user/actions.js